export default __webpack_public_path__ + "570bbc014aa0c2ea6bb08697169d98c0.png";